import { useMemo } from 'react';
import { usePeopleManagementApi } from 'infrastructure/api';
import { SYBERRY_TODAY_ALLOCATION_API_ENDPOINTS } from './endpoints';
import { readJsonResponse, withSyberryTodayApiError } from './response';
import { useStableSyberryTodayApiTransport, type SyberryTodayApiTransport } from './transport';
import type { SyberryTodayApiCurrentWeekAllocationResponse } from './types';

export type SyberryTodayAllocationApiClient = {
  getCurrentWeekAllocation: (employeeAlias: string) => Promise<SyberryTodayApiCurrentWeekAllocationResponse>;
};

export const createSyberryTodayAllocationApiClient = (
  transport: SyberryTodayApiTransport,
): SyberryTodayAllocationApiClient => ({
  getCurrentWeekAllocation: employeeAlias =>
    withSyberryTodayApiError(async () =>
      readJsonResponse<SyberryTodayApiCurrentWeekAllocationResponse>(
        await transport.sendGetRequest(SYBERRY_TODAY_ALLOCATION_API_ENDPOINTS.currentWeekAllocation(employeeAlias)),
      ),
    ),
});

export const useSyberryTodayAllocationApiClient = (): SyberryTodayAllocationApiClient => {
  const transport = useStableSyberryTodayApiTransport(usePeopleManagementApi());

  return useMemo(() => createSyberryTodayAllocationApiClient(transport), [transport]);
};
